import classNames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import type { AdornerProps } from './types'
import Box from '../../_primitives/box/box'

const Adorner: FC<AdornerProps> = props => {
  const {
    variant,
    className,
    anchorRect,
    dropdownRect,
    isTop,
    borderShadowEclipseThickness,
    ...rest
  } = props

  /* eslint-disable */
  const styleOverrides = useMemo(
    () =>
      dropdownRect && anchorRect
        ? {
            top: isTop ? dropdownRect.bottom : dropdownRect.top,
            left:
              dropdownRect.left > anchorRect.left
                ? dropdownRect.left + 1
                : anchorRect.left + 1,
            width:
              dropdownRect.left > anchorRect.left &&
              dropdownRect.right > anchorRect.right
                ? anchorRect.right - dropdownRect.left - 2
                : Math.min(anchorRect.width - 2, dropdownRect.width - 2)
          }
        : undefined,
    [
      isTop,
      dropdownRect && anchorRect,
      dropdownRect?.bottom,
      dropdownRect?.top,
      dropdownRect?.left,
      anchorRect?.left,
      dropdownRect?.right,
      anchorRect?.right,
      anchorRect?.width,
      dropdownRect?.width
    ]
  )
  /* eslint-enable */

  const sxOverrides = useMemo(
    () => ({
      transform: `translate(0px,${
        isTop ? -1 : -(borderShadowEclipseThickness - 1)
      }px)`,
      ...(isTop ? { borderTop: 'mediumGray' } : { borderBottom: 'mediumGray' })
    }),
    [isTop, borderShadowEclipseThickness]
  )

  if (!anchorRect || !dropdownRect) {
    return null
  }

  // eslint-disable-next-line no-console
  // console.log(`render Adorner isTop: ${isTop}`)
  return !(variant === 'primary' || variant?.includes('ghost')) ? (
    <Box
      className={classNames('csg-tui-popover-adorner', className)}
      absolute
      height={`${borderShadowEclipseThickness}px`}
      zIndex="selectButton"
      bg="white"
      sx={sxOverrides}
      style={styleOverrides}
      {...rest}
    />
  ) : null
}

export default Adorner
